import { normalize } from './normalize';

// maintain list of common feminine words in French used in custom labels
const feminineWordsFr = ['compétence', 'matière', 'activité', 'tâche'];

export function getGender(input: string): 'feminine' | 'masculine' {
  if (
    feminineWordsFr.some(word => normalize(input).startsWith(normalize(word)))
  ) {
    return 'feminine';
  }

  return 'masculine';
}
